/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react"
import CommonVars from "../components/CommonVars";
//socket button
import SocketButton from '../components/SocketButton';
import {
  useParams,

} from "react-router-dom"

import {
  Box,
  Container,
  Stack,
  Text,
  Image,
  Flex,
  VStack,
  Button,
  Heading,
  SimpleGrid,
  StackDivider,
  useColorModeValue,
  List,
  ListItem,
  } from "@chakra-ui/react";

import axios from "axios"

function OrderDetails() {
  // do the check
  if (localStorage.getItem('token') === null || JSON.parse(localStorage.getItem('userDetails')) === null) {
    window.location.replace("/unauthorized");
  }
  const [orderD, setAllOrderD] = useState("")
  // retrieve order id from params
  let { orderid } = useParams()
  // retrieve user details from localstorage
  const theToken = localStorage.getItem('token');
  const bUserDetails = JSON.parse(localStorage.getItem('userDetails'));
  const buserid = bUserDetails.userid;

  // do the check
  if (theToken == null || bUserDetails === false) {
		window.location.href = '/login';
    }

  const getOrderD = async () =>{
    axios.get(`${CommonVars.API_URL}/users/${buserid}/orders/${orderid}`, { headers: { Authorization: `Bearer ${theToken}` } })
    .then((response) =>{
        console.log(response.data)
        setAllOrderD(response.data)
    })
    .catch((error) =>{
        console.log(error)
    })
  }

  useEffect(() =>{
    getOrderD();
  }, [])

  const orderDArray = [];

  orderDArray.push(
    <Container maxW={"7xl"} key={orderid}>
      <SimpleGrid
        columns={{ base: 1, lg: 2 }}
        spacing={{ base: 8, md: 10 }}
        py={{ base: 18, md: 24 }}>          
        <Flex>
          <Image
            rounded={"md"}
            alt={"watch-image"}
            src={
              orderD.products_img_url
            }
            fit={"cover"}
            w={"100%"}
            h={{ base: "100%", sm: "400px", lg: "500px" }}
          />
        </Flex>
        <Stack spacing={{ base: 6, md: 10 }}>
          <Box as={"header"}>
            <Heading
              lineHeight={1.4}
              fontWeight={600}
              fontSize={{ base: "2xl", sm: "4xl", lg: "5xl" }}>
              {orderD.name}
            </Heading>
            <Text
              color={useColorModeValue("gray.900", "gray.400")}
              fontWeight={320}
              fontSize={"2xl"}>
              ${orderD.total} SGD
            </Text>
          </Box>

          <Stack
            spacing={{ base: 4, sm: 6 }}
            direction={"column"}
            divider={
              <StackDivider
                borderColor={useColorModeValue("gray.200", "gray.600")}
              />
            }>
            <VStack spacing={{ base: 4, sm: 6 }} alignItems={"flex-start"}>
              
              <Text
                color={useColorModeValue("gray.500", "gray.400")}
                fontSize={"2xl"}
                fontWeight={"300"}>
                Ordered By: {orderD.username}
              </Text>
              <Text fontSize={"lg"}>
                Absolutely mother awesome mate!
              </Text>
              <a href={`/user/${buserid}/product/${orderD.productid}/add-review`}>
                <Button
                  type="submit"
                  bg={'black'}
                  color={'white'}
                  _hover={{
                  bg: '#37404A',
                  }}
                >
                  Add Your Reviews?
                </Button>
              </a>
            </VStack>
            <Box>
              <Text
                fontSize={{ base: "16px", lg: "18px" }}
                color={useColorModeValue("yellow.500", "yellow.300")}
                fontWeight={"500"}
                textTransform={"uppercase"}
                mb={"4"}>
                Features
              </Text>

              <SimpleGrid columns={{ base: 1, md: 2 }} spacing={10}>
                <List spacing={2}>
                  <ListItem>Crafted to precision</ListItem>
                  <ListItem>On Time</ListItem>{" "}
                  <ListItem>Accurate</ListItem>
                </List>
                <List spacing={2}>
                  <ListItem>Water Proof</ListItem>
                  <ListItem>Comfortable</ListItem>
                  <ListItem>Not A Letdown</ListItem>
                </List>
              </SimpleGrid>
            </Box>
            <Box>
              <Text
                fontSize={{ base: "16px", lg: "18px" }}
                color={useColorModeValue("yellow.500", "yellow.300")}
                fontWeight={"500"}
                textTransform={"uppercase"}
                mb={"4"}>
                Order Details
              </Text>

              <List spacing={2}>
                <ListItem>
                  <Text as={"span"} fontWeight={"bold"}>
                    Order ID:
                  </Text>{" "}
                  {orderD.order_id}
                </ListItem>
                <ListItem>
                  <Text as={"span"} fontWeight={"bold"}>
                    Product Purchased:
                  </Text>{" "}
                  {orderD.name}
                </ListItem>
                <ListItem>
                  <Text as={"span"} fontWeight={"bold"}>
                    Shipped To:
                  </Text>{" "}
                  {orderD.shipping_address}
                </ListItem>
                <ListItem>
                  <Text as={"span"} fontWeight={"bold"}>
                    Total Paid:
                  </Text>{" "}
                  ${orderD.total} SGD
                </ListItem>
                <ListItem>
                  <Text as={"span"} fontWeight={"bold"}>
                    Payment Made By:
                  </Text>{" "}
                  {orderD.username}
                </ListItem>
              </List>
            </Box>
          </Stack>

          <Button
            rounded={"none"}
            w={"full"}
            mt={8}
            size={"lg"}
            py={"7"}
            bg={useColorModeValue("gray.900", "gray.50")}
            color={useColorModeValue("white", "gray.900")}
            textTransform={"uppercase"}
            _hover={{
              transform: "translateY(2px)",
              boxShadow: "lg",
            }}
            onClick = {() => {
              window.location.replace("/")
            }}>
            Continue Browsing WLD?
          </Button>
        </Stack>
      </SimpleGrid>
      {/* <Box position={"absolute"} bottom="0" right="0">
        <Button colorScheme='teal' size='md'>
          
        </Button>
      </Box> */}
    </Container>

    // <Box 
    // key={orderid}
    // display="grid" 
    // gridGap={2} 
    // gridAutoFlow="row dense">
    //   <Flex>
    //     <Image
    //       objectFit="cover"
    //       boxSize="100%"
    //       src={
    //           orderD.products_img_url
    //       }
    //     />
    //   </Flex>
      
    // </Box>
    // <Stack
    //   direction={["column", "row"]} key={orderid}
    //   w={{ sm: "100%", md: "540px" }}
    //   height={{ sm: "476px", md: "20rem" }}
    //   bg={bg}
    //   boxShadow={"2xl"}
    //   padding={4}>
    //   <Image
    //     objectFit="cover"
    //     boxSize="100%"
    //     src={
    //         orderD.products_img_url
    //     }
    //   />
    // </Stack>

  )

  return (
    <div className="Main">
      {orderDArray}
    </div>
  )
}

export default OrderDetails